module.exports = {
    isDev(){
        return process.env.NODE_ENV == "development" || process.env.NODE_ENV == "testing"
    },
    isUat(){
        return process.env.NODE_ENV == 'uat'
    },
    isProduction(){
        return process.env.NODE_ENV == 'production'
    },
    getAppId() {
        return process.env.NODE_ENV == 'production' ? 'wxae9b35b06db1a6f8' : 'wxc2f4219954d545d8'
    }
}